import React from 'react';
import { useNavigate } from 'react-router-dom';

function PaymentCancel() {
  const navigate = useNavigate();

  return (
    <div style={{ 
      maxWidth: '800px', 
      margin: '60px auto', 
      padding: '20px',
      textAlign: 'center'
    }}>
      <div className="card" style={{ 
        padding: '60px 40px',
        background: 'linear-gradient(135deg, #f59e0b 0%, #ef4444 100%)',
        color: 'white'
      }}>
        <div style={{ fontSize: '100px', marginBottom: '30px' }}>😔</div>
        
        <h1 style={{ fontSize: '42px', marginBottom: '20px' }}>
          Payment Cancelled
        </h1>
        
        <p style={{ fontSize: '20px', marginBottom: '30px', opacity: '0.95', lineHeight: '1.7' }}>
          Your payment was cancelled. No charges were made to your account.
        </p>

        <div style={{ 
          background: 'rgba(255,255,255,0.2)', 
          padding: '25px', 
          borderRadius: '12px',
          marginBottom: '30px'
        }}>
          <h3 style={{ fontSize: '20px', marginBottom: '15px' }}>What would you like to do?</h3>
          <p style={{ fontSize: '16px', opacity: '0.95', lineHeight: '1.7' }}>
            You can try again anytime, or continue using our free practice tests.
          </p>
        </div>

        <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <button 
            onClick={() => navigate('/pricing')}
            className="btn-primary"
            style={{ 
              background: 'white',
              color: '#ef4444',
              padding: '15px 40px',
              fontSize: '18px',
              fontWeight: 'bold'
            }}
          >
            Try Again
          </button>
          <button 
            onClick={() => navigate('/exams')}
            className="btn-secondary"
            style={{ 
              background: 'rgba(255,255,255,0.2)',
              color: 'white',
              border: '2px solid white',
              padding: '15px 40px',
              fontSize: '18px',
              fontWeight: 'bold'
            }}
          >
            Browse Free Tests
          </button>
        </div>

        <div style={{ 
          marginTop: '40px',
          fontSize: '14px',
          opacity: '0.9'
        }}>
          <p>
            Need help? Contact us at prepsmart.help@gmail.com
          </p>
        </div>
      </div>
    </div>
  );
}

export default PaymentCancel;
